<ng-template #positionDate>
  <div class="flex flex-col flex-wrap md:flex-row md:gap-3">
    <div class="flex flex-row gap-4">
      <tandem-form-input
        class="w-full lg:max-w-xs"
        [form]="dateRangeForm"
        [controlName]="'startDate'"
        [inputType]="'date'"
        [inputId]="'startDate'"
        [label]="'Start Date'"
        [placeholder]="'Start Date'"></tandem-form-input>
      <tandem-form-input
        class="w-full lg:max-w-xs"
        [form]="dateRangeForm"
        [controlName]="'endDate'"
        [inputType]="'date'"
        [inputId]="'endDate'"
        [label]="'End Date'"
        [placeholder]="'End Date'"></tandem-form-input>
    </div>
    <tandem-form-input
      [form]="dateRangeForm"
      [controlName]="'payYourselfPercentage'"
      [inputType]="'number'"
      [inputId]="'payYourselfPercentage'"
      [label]="'Pay Yourself First %'"
      [maskType]="'percent'"
      [placeholder]="'Pay Yourself First %'" suffixText="%"></tandem-form-input>
  </div>
</ng-template>
<div class="relative w-full flex flex-row justify-center items-start py-10 md:py-20 gap-x-20">
  <div class="w-1/5 max-sm:hidden mt-40 relative">
    <tandem-card *ngIf="activeSection" class="max-sm:hidden mt-40 fixed top-1/4 w-60">
      <div class="space-y-4">
        <ng-container *ngIf="currentPageNumber < spendingPlan.revenueSections.length">
            <p class="">{{getTotalText()}}</p>
        </ng-container>
        <ng-container *ngIf="currentPageNumber == spendingPlan.revenueSections.length">
            <p class="">Total Pay Yourself First Budget: {{getPYFBudget()}}</p>
            <p class="">{{getTotalText()}}</p>
            <p class=" font-semibold">{{getTotalRemainingPYFBudget()}}</p>
        </ng-container>
        <ng-container *ngIf="currentPageNumber > spendingPlan.revenueSections.length">
            <p class="">{{getTotalText()}}</p>
            <p class="">{{getTotalRemaining()}}</p>
        </ng-container>
      </div>
    </tandem-card>
  </div>

  <ng-container #section *ngIf="activeSection">
    <div class="flex w-full sm:w-4/5">
      <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-6xl">
        <div class="w-full max-sm:hidden">
          <div class="flex flex-row items-center">
            <div class="flex flex-col gap-y-3 w-full">
              <h1 class="text-4xl">{{activeSection ? activeSection.name : 'Summary'}}</h1>
              <h2 class="text-2xl">{{ activeSection.description || '' }}</h2>
            </div>
            <div class="flex flex-col gap-y-3 items-end">
              <h1 class="text-xl text-primary whitespace-nowrap">{{getPageLabel()}}</h1>
              <div class="flex flex-row gap-4 max-sm:hidden">
                <tandem-button  [onClick]="setPage.bind(this, currentPageNumber - 1)" color="white">Back</tandem-button>
                <tandem-button theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" color="primary" [disabled]="dateRangeForm.invalid">Next</tandem-button>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full sm:hidden">
          <div class="flex flex-col gap-y-3">
            <h1 class="text-2xl text-primary">{{getPageLabel()}}</h1>
            <h2 class="text-xl">{{ activeSection.hoverHint || '' }}</h2>
          </div>
        </div>
        <tandem-statement-item-table class="w-full" *ngFor="let cat of activeSection.categories" [statementItemCategory]="cat" [mode]="mode" (changesMade)="recalculateTotals()" [displayDate]="false"></tandem-statement-item-table>
        <div class="w-full">
          <div class="flex flex-col gap-y-3 sm:flex-row justify-between items-center">
            <span class="text-2xl font-semibold sm:order-2">{{getTotalText()}}</span>
            <tandem-button class="sm:order-3 w-full sm:w-fit" theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)" [disabled]="dateRangeForm.invalid">Next</tandem-button>
            <tandem-button *ngIf="currentPageNumber === 0" class="sm:order-1 w-full sm:w-fit" color="white" [onClick]="onSubmit.bind(this)" [disabled]="dateRangeForm.invalid">Save and Exit</tandem-button>
            <tandem-button *ngIf="currentPageNumber !== 0" class="sm:order-1 w-full sm:w-fit" color="white" [onClick]="setPage.bind(this, currentPageNumber - 1)">Back</tandem-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container #summary *ngIf="!activeSection">
    <div class="flex flex-col w-full">
      <div class="flex flex-col items-center w-full md:max-w-6xl mb-8 sm:mb-20">
        <div class="w-full max-sm:hidden">
          <div class="flex flex-row items-center">
            <div class="flex flex-col gap-y-3 w-full">
              <h1 class="text-4xl">Summary</h1>
              <h2 class="text-2xl">Let's see an overview of your {{getTrackingToolName('single')}}</h2>
            </div>
            <div class="flex flex-col gap-y-3 items-end">
              <h1 class="text-xl text-primary whitespace-nowrap">5 of 5: Summary</h1>
            </div>
          </div>
        </div>
        <div class="w-full sm:hidden">
          <div class="flex flex-col gap-y-3">
            <h1 class="text-2xl text-primary">5 of 5: Summary</h1>
            <h2 class="text-xl">Let's see an overview of your {{getTrackingToolName('single')}}</h2>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-5 md:gap-10 items-center w-full md:max-w-7xl">
        <div class="flex flex-col md:flex-row w-full gap-5 justify-between">
          <div class="flex flex-col justify-between h-full">
            <div class="flex flex-col gap-8">
              <div class="flex flex-col gap-y-3">
                <h2 class="text-2xl font-bold">Revenue</h2>
                <h5 class="text-lg">Total Revenue:  {{spendingPlan.totalRevenue | currency}}</h5>
              </div>
              <div class="flex flex-col gap-y-3">
                <h2 class="text-2xl font-bold">Expenses</h2>
                <h5 class="text-lg">Total Expenses:  {{spendingPlan.totalExpenses | currency}}</h5>
                <h5 class="text-lg" *ngFor="let section of spendingPlan.expenseSections; let i = index">{{getSummaryText('expense', section, i)}}</h5>
              </div>
            </div>
            <div class="flex flex-row justify-center gap-4 mt-8 max-md:hidden">
              <tandem-button color="white" [onClick]="setPage.bind(this, currentPageNumber - 1)">Back</tandem-button>
              <tandem-button color="primary" [onClick]="onSubmit.bind(this)" [disabled]="dateRangeForm.invalid">Submit</tandem-button>
            </div>
          </div>
          <tandem-spending-plan-graph class="w-full" style="height: 60vh" [spendingPlan]="spendingPlan"></tandem-spending-plan-graph>
          <div class="flex flex-col justify-center gap-4 md:hidden w-full">
            <tandem-button class="w-full" color="primary" [onClick]="onSubmit.bind(this)" [disabled]="dateRangeForm.invalid">Submit</tandem-button>
            <tandem-button class="w-full" color="white" [onClick]="setPage.bind(this, currentPageNumber - 1)">Back</tandem-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!--<div class="grid-container xl-max:w-full">-->
<!--  <div class="w-full flex flex-col gap-60 pb-50">-->
<!--    <div class="cols-18 h-50 flex flex-row">-->
<!--      <div class="cols-4 flex flex-row justify-center items-center gap-10">-->
<!--        <tandem-button  [onClick]="setPage.bind(this, currentPageNumber - 1)">BACK</tandem-button>-->
<!--        <tandem-button *ngIf="currentPageNumber !== 4" theme="solid" [onClick]="setPage.bind(this, currentPageNumber + 1)">NEXT</tandem-button>-->
<!--      </div>-->
<!--      <div class="cols-14 flex flex-row justify-between">-->
<!--        <div class="flex flex-col items-start gap-5 min-w-fit">-->
<!--          <div class="flex flex-row gap-5">-->
<!--            <h2>{{activeSection ? activeSection.name : 'Summary'}}</h2><tandem-tooltip *ngIf="activeSection?.hoverHint" [text]="activeSection?.hoverHint || ''"></tandem-tooltip>-->
<!--          </div>-->
<!--          <h4>{{activeSection ? activeSection.description : 'Let\'s review everything you entered'}}</h4>-->
<!--        </div>-->
<!--        <h3 class="w-fit text-primary">{{getPageLabel()}}</h3>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="flex flex-row cols-ml-1 gutter-gap-1">-->
<!--      <div class="cols-2 h-50 flex relative flex-col">-->
<!--        <ng-container *ngIf="currentPageNumber < spendingPlan.revenueSections.length">-->
<!--          <div class="flex flex-row fixed gap-15 p-15 overflow-auto bg-primary/20 rounded-sm">-->
<!--            <p class="text-16 cols-2">{{getTotalText()}}</p>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="currentPageNumber == spendingPlan.revenueSections.length">-->
<!--          <div class="fixed flex flex-col gap-15 bg-primary/20 rounded-sm p-15 overflow-auto ">-->
<!--          <div class="flex flex-row">-->
<!--            <p class="text-16 cols-2">Total Pay Yourself First Budget: {{getPYFBudget()}}</p>-->
<!--          </div>-->
<!--          <div class="flex flex-row">-->
<!--            <p class="text-16 cols-2">{{getTotalText()}}</p>-->
<!--          </div>-->
<!--          <div class="flex flex-row">-->
<!--            <p class="text-16 font-semibold cols-2">{{getTotalRemainingPYFBudget()}}</p>-->
<!--          </div>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="currentPageNumber > spendingPlan.revenueSections.length">-->
<!--          <div class="fixed flex flex-col gap-15 bg-primary/20 rounded-sm p-15 overflow-auto">-->
<!--          <div class="flex flex-row cols-2">-->
<!--            <p class="text-16">{{getTotalText()}}</p>-->
<!--          </div>-->
<!--            <div class="flex flex-row cols-2">-->
<!--              <p class="text-16">{{getTotalRemaining()}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--      </div>-->
<!--      <div class="cols-1 h-50 flex flex-row justify-center">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="2" height="609" viewBox="0 0 2 609" fill="none">-->
<!--          <path d="M1 0L1.00003 609" stroke="#636C7A" stroke-opacity="0.2"/>-->
<!--        </svg>-->
<!--      </div>-->
<!--      <div class="cols-13 flex flex-col gap-60 mb-100">-->
<!--        <div *ngIf="activeSection" class="flex flex-row gap-10">-->
<!--          <ng-container *ngIf="currentPageNumber < spendingPlan.revenueSections.length">-->
<!--            <tandem-form-input-->
<!--              [form]="dateRangeForm"-->
<!--              [controlName]="'startDate'"-->
<!--              [inputType]="'date'"-->
<!--              [inputId]="'startDate'"-->
<!--              [label]="'Start Date'"-->
<!--              [placeholder]="'Start Date'"></tandem-form-input>-->
<!--            <tandem-form-input-->
<!--              [form]="dateRangeForm"-->
<!--              [controlName]="'endDate'"-->
<!--              [inputType]="'date'"-->
<!--              [inputId]="'endDate'"-->
<!--              [label]="'End Date'"-->
<!--              [placeholder]="'End Date'"></tandem-form-input>-->
<!--          </ng-container>-->
<!--          <ng-container *ngIf="currentPageNumber == spendingPlan.revenueSections.length">-->
<!--            <tandem-form-input-->
<!--              [form]="dateRangeForm"-->
<!--              [controlName]="'payYourselfPercentage'"-->
<!--              [inputType]="'number'"-->
<!--              [inputId]="'payYourselfPercentage'"-->
<!--              [label]="'Pay Yourself First %'"-->
<!--              [placeholder]="'Pay Yourself First %'"></tandem-form-input>-->
<!--          </ng-container>-->
<!--        </div>-->
<!--        <div class="cols-4 flex flex-col text-red" *ngIf="dateRangeForm.hasError('dateRangeError')">-->
<!--          Invalid date selection.-->
<!--        </div>-->
<!--        <ng-container *ngIf="activeSection">-->
<!--          <tandem-statement-item-table *ngFor="let cat of activeSection.categories" [statementItemCategory]="cat" [mode]="mode" (changesMade)="recalculateTotals()"></tandem-statement-item-table>-->
<!--          <div class="flex flex-row justify-between">-->
<!--            <tandem-button theme="outline" [onClick]="onSubmit.bind(this)">SAVE AND EXIT</tandem-button>-->
<!--            <div class="flex flex-row gap-10">-->
<!--              <tandem-button *ngIf="currentPageNumber !== 0" theme="outline" [onClick]="setPage.bind(this, currentPageNumber - 1)">BACK</tandem-button>-->
<!--              <tandem-button theme="solid"-->
<!--                             [onClick]="setPage.bind(this, currentPageNumber + 1)"-->
<!--                             [disabled]="dateRangeForm.invalid"               >-->
<!--                NEXT-->
<!--              </tandem-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!activeSection">-->
<!--          <div class="flex flex-row cols-gap-1 items-center">-->
<!--            <div class="flex flex-col gap-40 justify-between">-->
<!--              <div class="flex flex-col gap-40">-->
<!--                <div class="flex flex-col gap-5">-->
<!--                  <h3>Total Revenue: {{spendingPlan.totalRevenue | currency}}</h3>-->
<!--                  <ng-container *ngIf="spendingPlan.revenueSections.length > 1">-->
<!--                    <h5 *ngFor="let section of spendingPlan.revenueSections; let i = index">{{getSummaryText('revenue', section, i)}}</h5>-->
<!--                  </ng-container>-->
<!--                </div>-->
<!--                <div class="flex flex-col gap-5">-->
<!--                  <h3>Total Expenses: {{spendingPlan.totalExpenses | currency}}</h3>-->
<!--                  <ng-container *ngIf="spendingPlan.expenseSections.length > 1">-->
<!--                    <h5 *ngFor="let section of spendingPlan.expenseSections; let i = index">{{getSummaryText('expense', section, i)}}</h5>-->
<!--                  </ng-container>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="w-full flex flex-row justify-between items-center">-->
<!--                <tandem-button theme="outline" [onClick]="setPage.bind(this, currentPageNumber - 1)">BACK: LIFESTYLE EXPENSES</tandem-button>-->
<!--                <tandem-button theme="solid" [onClick]="onSubmit.bind(this)">SUBMIT</tandem-button>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="w-full h-auto">-->
<!--              <tandem-spending-plan-graph [spendingPlan]="spendingPlan"></tandem-spending-plan-graph>-->
<!--            </div>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
